import { render, staticRenderFns } from "./retailManage.vue?vue&type=template&id=6da25d2f&scoped=true&"
import script from "./retailManage.vue?vue&type=script&lang=js&"
export * from "./retailManage.vue?vue&type=script&lang=js&"
import style0 from "./retailManage.vue?vue&type=style&index=0&id=6da25d2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da25d2f",
  null
  
)

export default component.exports